// Updated walkInForm.jsx with shared pricing calculations
import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import moment from 'moment';
import VehicleSelectForm from './../../vehicleSelection';
import ServiceForm from './../../newServiceForm';
import NotesForm from './../../notesForm';
import DatesForm from './../../dateWalkForm';
import CustomerForm from './../../newCustomerForm';
import { HTTPService } from "./../../../services/httpService";
import { convertToUTC } from '../../../util/convert_timezone';
// UPDATED: Import shared pricing module instead of old serviceUtils
import { 
  SharedRequestPricing, 
  SharedPricingUtils 
} from './../services/sharedPricingCalculations';
import ReactGA from 'react-ga4';
import _ from 'lodash';

const API = new HTTPService();

class WalkinForm extends Component {

  constructor(props) {

    super(props);

    // Get referral data immediately for initial state
  const referralData = this.props.location?.state?.referralData;

    this.state = {
      redirect: false,
      currentStep: 1,
      // REMOVED: hardcoded platformFee - will use shared config
      customer: referralData?.customer || "",
      customerName: referralData?.customerName || "",
      customerEmail: referralData?.customerEmail || "", // ADD THIS LINE
      customerType: referralData ? "retail" : "",
      vehicle: referralData?.vehicle || '',
      services: [],
      total : 0,
      discount : 0,  // UPDATED: Now properly tracks discounts
      fee : 0,
      loading:false,
      notes:"",
      taxRate : 0,
      taxPercent : 0,
      availableDate: new moment().startOf('day'),
      dueDate: new moment().startOf('day'),
      newVehicleId: {},
      newRequestId: {},
      user: this.props.user,
      excludeDays : [],
      dealerships : [],
      authenticated : 0,
      serviceHint: referralData?.requestedService || null, // ADD THIS LINE
      referralId: referralData?.referralId || null, // ADD THIS LINE
    };
    
    this.handleChange = this.handleChange.bind(this);
    this.handleServices = this.handleServices.bind(this);
    this.handleCustomer = this.handleCustomer.bind(this);
    this.handleVIN = this.handleVIN.bind(this);
    this.handleNotes = this.handleNotes.bind(this);
    this.handleDueDate = this.handleDueDate.bind(this);
    this.handleAvailableDate = this.handleAvailableDate.bind(this);
    this._next = this._next.bind(this);
    this._prev = this._prev.bind(this);
this.handleStockNumberChange = this.handleStockNumberChange.bind(this);
this.handleDealNumberChange = this.handleDealNumberChange.bind(this);
  }

  async componentDidMount() {

    let installerRequest = "/installerLocations/"+this.props.typeId;        
    const  { data : installer }  =  await API.get(installerRequest);
   
    const firstOne = installer.shift();
    this.setState({ installer : firstOne });  
//    //console.log("Installer : ",this.state.installer);
    let taxRequest = "/taxes/"+this.state.installer.stripe_tax_rate;        
    const  { data : taxRate }  =  await API.get(taxRequest);
    this.setState({ taxPercent : taxRate.percentage });    
      //read the installer calendar to manage the bookings
  
      let calendarRequest = "/dealerCalendars/"+this.props.typeId;
    
      const  { data : dealerCalendarDays }  = await API.get(calendarRequest);
    
      calendarRequest = "/installerCalendars/"+this.props.typeId;
    
      const  { data : installerCalendarDays }  = await API.get(calendarRequest);
    
      var calendarList = dealerCalendarDays.concat(installerCalendarDays);
    
      var calendarDays = _.orderBy(calendarList, ['workDate'],['asc']);
      this.setState({ calendarDays });
    
      // Create the array of the booked calendar services in the upcoming 60 days
    
      if (calendarDays.length > 0){
        const startDate = moment.utc().format("YYYY-MM-DD");
            
//           //console.log("CC - start Date", startDate);
        var totalDuration = 60;
        
        // caalendarInWindow
        var bookedArray = calendarDays.filter(day => moment.utc(day.workDate).diff(startDate) >= 0);
    
//         //console.log( "Upcoming calendar : ", bookedArray);    
//         //console.log("CC - start Date", startDate);
//         //console.log("Installer :", this.state.installer);
        
        //capacityCalendar
        var bookedData = new Array(totalDuration);
    
        for (var m=0; m < totalDuration; m++) {
          bookedData[m] = {'x' : m, 'exDate' : moment.utc(startDate).add(m,"days").format("YYYY-MM-DD") ,'y' : 0};
      };  
    
      // Need to build the array of booked capacity here for the next 60 days
      for (var k=0; k < bookedData.length; k++ ){
        // for every day in the calendar days, add up the daily_work and assign it to the right day
        let matchingWork = bookedArray.filter(work => moment.utc(work.workDate).format("YYYY-MM-DD") === bookedData[k].exDate);
        let dayTotal = matchingWork.reduce( function (result, value) {
          return result + value.capacity 
        } , 0) 
        bookedData[k].y = dayTotal;
      };

      let exclude = [];
//       //console.log ("Booked data length :", bookedData.length)
      for (let b=0; b< bookedData.length; b++){
        // this should be the capacity of the installer vs the size of job
        if (bookedData[b].y >= this.state.installer.capacity * 2){
//           //console.log ("Exclude :", new Date(moment(bookedData[b].exDate).format("MMMM D, YYYY")));
          exclude.push(new Date(moment(bookedData[b].exDate).format("MMMM D, YYYY")));
        }
    }
    
          this.setState( { excludeDays : exclude, bookedDays : bookedData});
    //      //console.log("Booked Array :", bookedData);
    //      //console.log("Excluded dates :", exclude)    
          };
    // read the dealerships to populate the dealer table      
          let dealerRequest = "/dealers";        
          const  { data : dealerships }  =  await API.get(dealerRequest);
          this.setState( {dealerships});

      //check if authenticated 
      await this.readAuth(this.props.typeId);
      // Referral data is already set in constructor, just log for confirmation
      const referralData = this.props.location?.state?.referralData;
      if (referralData) {
        console.log("Referral data processed in componentDidMount:", {
          customer: this.state.customer,
          customerName: this.state.customerName,
          customerEmail: this.state.customerEmail,
          vehicle: this.state.vehicle,
          referralId: this.state.referralId
        });
      }
  };

checkVehicleComplete = () => {
    const vehicle = this.state.vehicle;
    
    // Must have ALL required fields for service catalog accuracy
    const isComplete = vehicle && 
           vehicle.year && 
           vehicle.make && 
           vehicle.model && 
           vehicle.trim && 
           vehicle.body &&
           vehicle.id_car_trim; // This is critical for service catalog
        
    return isComplete;
};

handleSubmit = async (e, createAppointment = false) => {
  e.preventDefault();
  this.setState({ loading: true });

  try {
    console.log("Starting job creation with services:", this.state.services);
    console.log("Create appointment:", createAppointment);

    // Validate services before proceeding
    const validationResult = SharedPricingUtils.validatePricingData(this.state.services);
    if (!validationResult.isValid) {
      throw new Error(`Pricing validation failed: ${validationResult.errors.join(', ')}`);
    }

    // Determine job type and tax configuration
    const jobType = this.state.customerType === "whole" ? "dealer" : "retail";
    const taxRate = this.state.customerType === "whole" ? 0 : this.state.taxPercent;

    // Get complete pricing breakdown using shared module
    const pricingBreakdown = SharedRequestPricing.getCompletePricingBreakdown(this.state.services, {
      jobType: jobType,
      taxRate: taxRate
    });

    console.log("Pricing breakdown for installer job:", pricingBreakdown);

    // STEP 1: Complete ALL Jobvious database work first
    console.log("Starting job creation process...");

    // Add vehicle if needed
    if (!this.state.vehicle.id) {
      console.log("Adding vehicle...");
      await this.addVehicle();
    }

    // Add the main request with calculated pricing
    console.log("Adding request...");
    const newRequest = await this.addRequest(pricingBreakdown, createAppointment);

    // Add the requestState record - use "scheduled" if booking appointment, otherwise "created"
    const initialStatus = (this.state.customerType === "whole" || createAppointment) ? "scheduled" : "created";
    console.log("Adding request state...", initialStatus);
    await this.addRequestState(newRequest, initialStatus, null);

    // Add note (FIX: Added missing await)
    console.log("Adding note...");
    await this.addNote(newRequest);
    
    // Add services with calculated pricing
    console.log("Adding services...");
    await this.addServices(newRequest, pricingBreakdown);
    
    // Add request offered
    console.log("Adding request offered...");
    await this.addOffer(createAppointment);
    
    // Add Jobvious calendar entries 
    console.log("Adding to Jobvious calendar...");
    await this.addCalendar();

    console.log("✅ Core job creation completed successfully");

    // STEP 2: Update referral status if this came from a referral
    if (this.state.referralId) {
      console.log("Updating referral status for referral ID:", this.state.referralId);
      try {
        await this.updateReferralStatus(this.state.referralId, newRequest);
        console.log("✅ Referral status updated to ESTIMATE_CREATED");
      } catch (referralError) {
        console.error("Failed to update referral status:", referralError);
        // Don't fail the entire flow
      }
    }

    // STEP 3: Attempt Google Calendar sync as silent bonus feature
    if ((this.state.customerType === "whole" || createAppointment) && this.state.authenticated) {
      console.log("Attempting Google Calendar sync...");
      try {
        await this.addAppointmentSilently(newRequest);
        console.log("✅ Google Calendar sync completed as bonus");
      } catch (calendarError) {
        console.log("Google Calendar sync skipped (optional feature):", calendarError.message);
        // Completely silent - no user notification for calendar failures
      }
    }

    // STEP 4: Send email notification if creating appointment for retail
    if (createAppointment && this.state.customerType !== "whole") {
      console.log("Sending booking confirmation email...");
      try {
        await this.sendEmail(newRequest);
        console.log("✅ Booking email sent");
      } catch (emailError) {
        console.log("Email notification skipped:", emailError.message);
        // Silent - don't fail the flow
      }
    }

    // STEP 5: Complete workflow based on job type
    this.setState({ loading: false });

    if (this.state.customerType !== "whole") {
      if (createAppointment) {
        alert("Job booked successfully! Appointment created and confirmation email sent.");
        ReactGA.event({category: 'Installer', action: 'Created and Booked Estimate', label: 'prod'});
        window.location = "/jobs";  // Redirect to jobs when appointment is booked
      } else {
        alert("Adding the estimate to your list");
        ReactGA.event({category: 'Installer', action: 'Created Estimate', label: 'prod'});
        window.location = "/requestimates";  // Redirect to estimates when just creating estimate
      }
    } else {
      alert("Adding this dealer work to your calendar");
      window.location = "/jobs";
      ReactGA.event({category: 'Installer', action: 'Created Job', label: 'prod'});
    }

  } catch (error) {
    console.error('❌ Error creating job:', error);
    this.setState({ loading: false });
    alert('Error creating job: ' + error.message);
  }
};

// ADD this new silent calendar sync method (same pattern as requestimates.jsx):
addAppointmentSilently = async (requestId) => {
  try {
    console.log("Silent calendar sync starting for request:", requestId);
    
    // Use the same server endpoints as the working requestimates.jsx code
    let readAppt = `/readAppt/${requestId}`;
    const { data: appt } = await API.get(readAppt);

    if (!appt || appt.length === 0) {
      throw new Error('No appointment data found for calendar sync');
    }

    let newAppt = {
      request: requestId,
      summary: `${appt[0].Year} ${appt[0].Make} ${appt[0].Model}`,
      description: `Customer: ${this.state.customerName || 'Dealer Job'}`,
      calendar: appt[0].calendar_id,
      startDate: appt[0].work_date,
      duration: appt[0].request_duration,
      installerId: this.props.typeId,
    };

    console.log("Sending to Google Calendar:", newAppt);
    
    let apptAdd = `/addAppt/`;
    const response = await API.put(apptAdd, newAppt);
    
    console.log("Google Calendar response:", response.data);
    return response.data;
    
  } catch (error) {
    // Silent failure - just log, don't throw
    console.log('Silent Google Calendar sync failed:', error.message);
    return null;
  }
};

// Add this method to WalkInForm
updateReferralStatus = async (referralId, requestId) => {
  const updateData = {
    referralId: referralId,
    status: 'ESTIMATE_CREATED',
    requestId: requestId  // Link the referral to the created request
  };

  const response = await API.put('/referrals', updateData);
  return response.data;
};

// Send booking confirmation email to customer
sendEmail = async (request) => {
  console.log("📧 FRONTEND: Initiating booking email send for request:", request);
  console.time(`📧 Frontend Email Send - ${request}`);

  try {
    const response = await API.get(`/sendemailb/${request}`);
    console.timeEnd(`📧 Frontend Email Send - ${request}`);

    console.log("📧 FRONTEND: Email API response:", response.data);

    if (response.data && response.data.success) {
      console.log("✅ FRONTEND: Booking email sent successfully for request:", request);
      return true;
    } else if (response.status === 200 && !response.data.success) {
      // Handle legacy success response (HTTP 200 but no JSON success flag)
      console.log("✅ FRONTEND: Booking email sent (legacy response) for request:", request);
      return true;
    } else {
      console.error("❌ FRONTEND: Failed to send booking email:", {
        request,
        response: response.data
      });
      return false;
    }
  } catch (error) {
    console.error("❌ FRONTEND: Error sending booking email:", error);
    return false;
  }
};
  // Use the submitted data to set the state
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    })
  }
handleStockNumberChange(stockNumber) {
  // No-op - fields won't show for installers anyway
}

handleDealNumberChange(dealNumber) {
  // No-op - fields won't show for installers anyway  
}
  handleCancel = e => {
    e.preventDefault();
    ReactGA.event({category: 'Installer', action: 'Cancel Estimate', label: 'prod'});
    this.props.history.push("/requestimates");
    return;
  }

  handleNotes(notes) {
    this.setState({notes})
  }

// UPDATED: Use shared pricing calculations
handleServices(services, total, discount) {
  console.log("handleServices called with:", { services, total, discount });
  
  // Validate the totals using shared pricing module
  const calculatedTotal = SharedRequestPricing.calculateRequestTotal(services);
  const calculatedDiscount = SharedRequestPricing.calculateRequestDiscount(services);
  
  // Log comparison for debugging
  if (Math.abs(total - calculatedTotal) > 0.01 || Math.abs(discount - calculatedDiscount) > 0.01) {
    console.warn("Total mismatch detected:", {
      passedTotal: total,
      calculatedTotal: calculatedTotal,
      passedDiscount: discount,
      calculatedDiscount: calculatedDiscount
    });
  }
  
  // Use calculated values for consistency
  this.setState({
    services, 
    total: calculatedTotal,      // Use shared calculation
    discount: calculatedDiscount // Use shared calculation
  });
}

  handleCustomer(customer, customerName, customerType) {
    //    //console.log("Handle Customer selection", customer);
        this.setState({customer, customerName, customerType});
      }
    
// In WalkInForm - Enhanced handleVIN method
handleVIN(vehicle) {
    console.log("Update vehicle state", vehicle);
    this.setState({ vehicle }, () => {
        // Only auto-advance if this is a referral AND vehicle is FULLY complete
        if (this.state.referralId && this.checkVehicleComplete()) {
            // Add a small delay to ensure all UI updates are complete
            setTimeout(() => {
                if (this.checkVehicleComplete()) { // Double-check after delay
                    console.log("Referral vehicle fully populated - auto-advancing to step 3");
                    this.setState({ currentStep: 3 });
                }
            }, 500);
        }
    });
}
// Separate method to check vehicle completion
checkVehicleComplete = () => {
    return this.state.vehicle && 
           this.state.vehicle.year && 
           this.state.vehicle.make && 
           this.state.vehicle.model && 
           this.state.vehicle.trim && 
           this.state.vehicle.body;
};

handleDueDate(date) {
    this.setState({ dueDate: date })
  }

  handleAvailableDate(date) {
    this.setState({availableDate: date})
  }

  readAuth = async (installerId) => {
    let installerRequest = `/installerAuth/${installerId}`;
    const  { data : installer }  =  await API.get(installerRequest);
  //  //console.log("Installer :", installer);
    this.setState( {authenticated : installer[0].authenticated, auth : installer[0]});
  }

  addRequestState = async (requestId, requeststate, requestService) => {
    const state = {
      requestId: requestId,
      stateDate: convertToUTC(new Date()).format("YYYY/MM/DD HH:mm:ss"),
      requestStatus: requeststate,
      serviceId: requestService,
      changedByUserId: this.props.typeId,
      changedByUserType: this.props.userType
    };

    const apiEndpoint = `/requestState`;
    await API.post(apiEndpoint, state);
    return null;
  };

  // create a jumbo object of requestimate and vehicle and send it to a service
  addVehicle = async () => {
    const { vehicle } = this.state;
    const { data: newVehicleId } = await API.post(`/vehicles`, vehicle);
     return null;
  };

  addCalendar = async () => {
    let calendar = {
      requestId: this.state.newRequestId,
      installerId : this.props.typeId,
      installerCapacity : this.props.capacity,
      startDate : convertToUTC(this.state.availableDate).format("YYYY/MM/DD HH:mm:ss")
    }
    // take the work requested and create the draft calendar entries 
    const { data : newCalendar } = await API.post(`/schedule/`, calendar)
    
    return newCalendar;
    }

    addAppointment = async (appointment) => {
         let readAppt = `/readAppt/${appointment}`;        
         const { data: appt } = await API.get(readAppt);
     
     //    //console.log("Here's the data for the appointment :", appt);
     //    //console.log("description :", description);
        let calEntry = appt[0];
      //console.log("AddAppt : auth object : ", this.state.auth);
        let summary = `${calEntry.Year} ${calEntry.Make} ${calEntry.Model}`;
         let newAppt = {
             request : appointment,
             summary : summary,
             calendar : this.state.auth.calendar_id,
             description : "",
             startDate : calEntry.work_date,
             duration : calEntry.request_duration,
             token : calEntry.refresh_token
         };
         //console.log ("AddAppointment : Add to the calendar ", newAppt);
     
         let apptAdd = `/addAppt/`;        
         const { data: addAppt } = await API.put(apptAdd, newAppt);
         return;
     };
    
addNote = async (newRequestId) => {
  if (!this.state.notes) {
    console.log("No notes to add, skipping...");
    return null;
  }

  let newNote = {
    requestId: newRequestId || this.state.newRequestId,
    noteDate: convertToUTC(new Date()).format("YYYY/MM/DD hh:mm:ss"),
    noteText: this.state.notes,
    userType: this.props.userType,
    userId: this.props.typeId
  }

  console.log("Adding note:", newNote);
  const { data: newRequestNote } = await API.post("/requestnotes/", newNote);
  return newRequestNote;
};

// UPDATED: Use shared pricing calculations for request creation
addRequest = async (pricingBreakdown, createAppointment = false) => {

  console.log("Tax debugging when adding the request:", {
  taxPercent: this.state.taxPercent,
  customerType: this.state.customerType,
  finalAmount: pricingBreakdown.finalAmount,
  calculatedTax: pricingBreakdown.taxes
});

  let newRequest = {
    requestType: this.props.userType,
    requestor: this.state.customer,
    serviceRequested: this.state.services[0].service_category + " " + this.state.services[0].description,
    // UPDATED: Use calculated values from pricing breakdown
    requestTotal: pricingBreakdown.originalTotal,      // Original total (before discounts)
    requestDiscount: pricingBreakdown.totalDiscount,   // Total discount amount
    requestFee: pricingBreakdown.platformFee,          // NEW: Post-discount fee
    requestDuration: pricingBreakdown.totalDuration,   // Total duration
    requestTaxes: pricingBreakdown.taxes,              // Tax amount (varies by job type)
    assignedTo: this.props.typeId,
    createdBy: this.props.typeId,
    availableDate:  convertToUTC(this.state.availableDate).format("YYYY/MM/DD HH:mm:ss"),
    dueDate: convertToUTC(this.state.availableDate).format("YYYY/MM/DD HH:mm:ss"),
    currentState: "new",
    createdDate: convertToUTC(new Date()).format("YYYY/MM/DD HH:mm:ss"),
    vin: this.state.vehicle.vin,
    createdType : "installer",
    installerCatalog : this.props.typeId
  }

  // If this is a wholesale request entered by the installer
  if (this.state.customerType === "whole") {
    newRequest.requestType = "dealer";
    newRequest.currentState = "scheduled";
  }

  // If this is a retail walk-in being booked as an appointment, set as scheduled
  if (this.state.customerType !== "whole" && createAppointment) {
    newRequest.currentState = "scheduled";
  }

  // process the services requested array to create the right value
  if (this.state.services.length > 1) {
    newRequest.serviceRequested = newRequest.serviceRequested + " + " + (this.state.services.length-1);
  }

  const { data: newRequestId } = await API.post("/requestimates/", newRequest);
  this.setState({ newRequestId });
  return newRequestId;
}

// UPDATED: Use shared pricing calculations for services
addServices = async (requestId, pricingBreakdown) => {
  console.log("Services being saved:", this.state.services);
  console.log("Pricing breakdown:", pricingBreakdown);
  
  // Determine job type for submission
  const jobType = this.state.customerType === "whole" ? "dealer" : "retail";
  const taxRate = this.state.customerType === "whole" ? 0 : this.state.taxPercent;
  
  // Prepare services using shared pricing module
  const submissionData = SharedPricingUtils.prepareForSubmission(this.state.services, {
    jobType: jobType,
    taxRate: taxRate
  });
  
  const newRequestService = {
    requestId: await requestId,
    serviceId: "",
    serviceAmount: 0,
    serviceValue: 0,         // NEW: Final amount after discount
    serviceDiscount: 0,
    serviceDuration: 0,
    serviceFee: 0,           // NEW: Service-level fee
    serviceState: "new",
    serviceDate: convertToUTC(new Date()).format("YYYY/MM/DD HH:mm:ss"),
    customDescription: "",
    retailPrice: 0
  }
  
  for (let i = 0; i < submissionData.services.length; i++) {
    const service = submissionData.services[i];
    
    // UPDATED: Use calculated values from shared pricing module
    newRequestService.serviceId = service.service_id;
    newRequestService.serviceAmount = service.service_amount;     // Original amount
    newRequestService.serviceValue = service.service_value;       // Final amount after discount
    newRequestService.serviceDiscount = service.service_discount; // Discount amount
    newRequestService.serviceDuration = service.service_duration; // Duration
    newRequestService.serviceFee = service.service_fee;           // Service-level fee (post-discount)
    newRequestService.customDescription = service.custom_description || service.description;
    newRequestService.retailPrice = service.retail_price || null;
    
    console.log(`Service ${i + 1}:`, {
      serviceId: service.service_id,
      description: service.description,
      serviceAmount: service.service_amount,
      serviceValue: service.service_value,
      serviceDiscount: service.service_discount,
      serviceFee: service.service_fee,
      retailPrice: service.retail_price
    });
    
    await API.post("/requestService", newRequestService);
  }
  return null;
}
 
addOffer = async (createAppointment = false) => {
  // Determine the correct status - "scheduled" if booking appointment or dealer job, otherwise "offered"
  const offerStatus = (this.state.customerType === "whole" || createAppointment) ? "scheduled" : "offered";

  const newRequestOffer = {
    requestId: this.state.newRequestId,
    installerId: this.props.typeId,
    currentStatus : offerStatus,
    dateUpdated: convertToUTC(new Date()).format("YYYY/MM/DD HH:mm:ss"),
    startDate: convertToUTC(this.state.availableDate).format("YYYY/MM/DD HH:mm:ss"),
    endDate: convertToUTC(this.state.availableDate).format("YYYY/MM/DD HH:mm:ss")
  }
console.log("Sending requestOffer with status:", offerStatus, newRequestOffer);

  await API.post("/requestoffered", newRequestOffer);
  return null;
};


  _next() {
    let currentStep = this.state.currentStep
    // If the current step is 1 or 2, then add one on "next" button click
    currentStep = currentStep >= 4 ? 5 : currentStep + 1
    this.setState({ currentStep: currentStep })
  }

  _prev() {
    let currentStep = this.state.currentStep
    // If the current step is 2 or 3, then subtract one on "previous" button click
    currentStep = currentStep <= 1 ? 1 : currentStep - 1
    this.setState({ currentStep: currentStep })
  }

  // The "next" and "previous" button functions
  get previousButton() {

    let currentStep = this.state.currentStep;

    // If the current step is not 1, then render the "previous" button
    if (currentStep !== 1) {
      return (<button className="btn btn-success buttons" type="button" onClick={this._prev}> PREV</button>)
    }

    // ...else return nothing
    return null;

  }

  get nextButton() {
    let currentStep = this.state.currentStep;
    // If the current step is not 4, then render the "next" button
    if(currentStep < 5){
        let disable = true;
        if (currentStep === 1 && this.state.customer) {
          disable = false;
        }
        if (currentStep === 2 && this.state.vehicle) {
          disable = false;
        }
        if (currentStep === 3 && this.state.services.length > 0) {
          disable = false;
        }
        if (currentStep === 4) {
          disable = false;
        }
      return (
        <button 
          className="btn btn-success float-right buttons" 
          type="button" disabled={disable} onClick={this._next}>
        NEXT
        </button>        
      )
    } else {
      // ... must be the submit time...
      // For dealer jobs, always book appointment automatically
      // For retail jobs, show two buttons: estimate only or book appointment
      if (this.state.customerType === "whole") {
        return (
          <button
            className="btn btn-primary float-right"
            type="button"
            onClick={(e) => this.handleSubmit(e, true)}
            disabled={this.state.loading}>
            {this.state.loading && <span>
              <i className="fa-solid fa-arrows-rotate fa-spin" />
            </span>}
            {!this.state.loading && <span>Create Job</span>}
          </button>
        );
      } else {
        // Retail customer - show two options
        return (
          <React.Fragment>
            <button
              className="btn btn-outline-primary mr-2"
              type="button"
              onClick={(e) => this.handleSubmit(e, false)}
              disabled={this.state.loading}>
              {this.state.loading && <span>
                <i className="fa-solid fa-arrows-rotate fa-spin" />
              </span>}
              {!this.state.loading && <span>Create Estimate</span>}
            </button>
            <button
              className="btn btn-success"
              type="button"
              onClick={(e) => this.handleSubmit(e, true)}
              disabled={this.state.loading}>
              {this.state.loading && <span>
                <i className="fa-solid fa-arrows-rotate fa-spin" />
              </span>}
              {!this.state.loading && <span><i className="fa-solid fa-calendar"></i> Book Appointment</span>}
            </button>
          </React.Fragment>
        );
      }
    }

  };

  get steepOne () {
    if (!this.state.customer) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white">
            </button>
            <br />
            Customer
            <div className="line-50-right"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-solid fa-check"></i>
          </button>
          <br />
          Customer
          <div className="line-50-right"></div>
        </div>
      </li>
    );
  };
  get steepTwo () {
    if (!this.state.vehicle) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white">
            </button>
            <br />
            Vehicle
            <div className="line-100"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-solid fa-check"></i>
          </button>
          <br />
          Vehicle
          <div className="line-100"></div>
        </div>
      </li>
    );
  };
  get steepThree () {
    if (this.state.services < 1) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white"></button>
            <br />
            Work
            <div className="line-100"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-solid fa-check"></i>
          </button>
          <br />
          Work
          <div className="line-100"></div>
        </div>
      </li>
    );
  };
  get steepFour () {
    if (!this.state.notes) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white"></button>
            <br />
            Notes
            <div className="line-100"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-solid fa-check"></i>
          </button>
          <br />
          Notes
          <div className="line-100"></div>
        </div>
      </li>
    );
  };
  get steepFive () {
    if (this.state.currentStep !== 5 && this.state.dueDate) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white"></button>
            <br />
            Dates
            <div className="line-50-left"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-solid fa-check"></i>
          </button>
          <br />
          Dates
          <div className="line-50-left"></div>
        </div>
      </li>
    );
  };


  // This is also where when all the validation is completed, we push the new record
  // and redirect the page to the requestimate form with the parameters set
  render() {

    return (
      <React.Fragment>
        <div className="bg-white border border-secondary">
          <div className="col-lg-12 text-right">
            <button className="btn" type="button" onClick={this.handleCancel}>
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div className="col-lg-12 d-flex justify-content-center">
            <ul className="col-lg-5 nav nav-pills nav-fill text-center">
              {this.steepOne}
              {this.steepTwo}
              {this.steepThree}
              {this.steepFour}
              {this.steepFive}
            </ul>
          </div>
          <br />
          <br />
          <br />
          <div className="col-lg-12 p-0">
            <CustomerForm 
                currentStep={this.state.currentStep} 
                userType = "installer"
                vehicle={this.state.vehicle}
                availableDate = {this.state.availableDate}
                dueDate = {this.state.dueDate}
                services={this.state.services}
                notes = {this.state.notes}
                dealerships = {this.state.dealerships}
                handleCustomer={this.handleCustomer}
                installer={this.state.installer}
                mode={"search"}
                customer={this.state.customer}
                customerName={this.state.customerName}
                customerEmail={this.state.customerEmail}
                customerType={this.state.customerType}
                />       
            <VehicleSelectForm
              currentStep={this.state.currentStep}
              handleVIN={this.handleVIN}
                onStockNumberChange={this.handleStockNumberChange}  // ADD THIS LINE
              notes = {this.state.notes}
              default = {""}
              customer = {this.state.customer}
              installer = {this.state.installer}
              customerType= {this.state.customerType}
              userType={"installer"}
              vehicle={this.state.vehicle} />
            <ServiceForm
                userType={this.props.userType}
                typeId={this.props.typeId}
                currentStep={this.state.currentStep} 
                handleServices={this.handleServices}
                total={this.state.total}
                customerType= {this.state.customerType}
                vehicle={this.state.vehicle}
                discount={this.state.discount}
                category={"Paint"}
                services={this.state.services}
                notes = {this.state.notes}
                serviceHint={this.state.serviceHint}/>
            <NotesForm 
                currentStep={this.state.currentStep} 
                vehicle={this.state.vehicle}
                userType = "installer"
                requestType = {this.state.customerType}
                availableDate = {this.state.availableDate}
                dueDate = {this.state.dueDate}
                services={this.state.services}
                notes = {this.state.notes}
                handleNotes={this.handleNotes}
                  onDealNumberChange={this.handleDealNumberChange}  // ADD THIS LINE
                />       
            <DatesForm
                userType={this.props.userType}
                typeId={this.props.typeId}
                currentStep={this.state.currentStep} 
                handleAvailableDate={this.handleAvailableDate}
                availableDate={this.state.availableDate}
                vehicle={this.state.vehicle}
                services={this.state.services}
                notes={this.state.notes}
                discount={this.state.discount}
                customer={this.state.customerName}
                excludeDays={this.state.excludeDays}
            />


            <div className="m-5 d-flex justify-content-center">
              {/* <pre>{this.state.vehicle}</pre> */}
              <div className="p-2">
                {this.previousButton}
              </div>
              <div className="p-2">
                {this.nextButton}
              </div>
            </div>

          </div>
        </div>
      </React.Fragment>
    );
  };

}
export default withRouter(WalkinForm);